function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  transform: "translate(-1237 -4665) translate(0 4345) translate(340 130) translate(0 178)"
}, React.createElement("g", null, React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.8
}, React.createElement("g", null, React.createElement("g", {
  strokeLinejoin: "round"
}, React.createElement("g", null, React.createElement("path", {
  d: "M14.702 13.34v5.667c0 .732-.594 1.325-1.325 1.325H1.325C.593 20.332 0 19.739 0 19.007V1.785C0 1.053.593.46 1.325.46h8.78c.351 0 .688.14.937.388l3.279 3.279c.214.226.347.481.399.764v.629",
  transform: "translate(850) translate(47 12) translate(16.5 15.5) translate(0 4.6)"
})), React.createElement("g", null, React.createElement("path", {
  d: "M0 2.76V1.325C0 .593.593 0 1.325 0h8.428c.53 0 1.04.21 1.414.586l3.685 3.684c.375.375.586.884.586 1.414v12.863h0c0 .732-.594 1.325-1.325 1.325H10.12",
  transform: "translate(850) translate(47 12) translate(16.5 15.5) translate(7.36)"
}))), React.createElement("path", {
  d: "M10.58 13.8L18.86 13.8",
  transform: "translate(850) translate(47 12) translate(16.5 15.5)"
}), React.createElement("path", {
  strokeLinejoin: "round",
  d: "M10.58 12.648L10.58 14.948 12.88 14.948",
  transform: "translate(850) translate(47 12) translate(16.5 15.5) rotate(45 11.73 13.798)"
}), React.createElement("path", {
  strokeLinejoin: "round",
  d: "M16.1 12.648L16.1 14.948 18.4 14.948",
  transform: "translate(850) translate(47 12) translate(16.5 15.5) scale(-1 1) rotate(45 0 -27.847)"
})), React.createElement("path", {
  strokeLinejoin: "round",
  d: "M19.6 25.56L24.6 25.56M19.6 28.76L21.6 28.76",
  transform: "translate(850) translate(47 12)"
}))))))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/page-reference.82825eac.svg";
export { SvgComponent as ReactComponent };